import React, {useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import "./BotoneraSite.css"

import { useNavigate, NavLink, Navigate } from "react-router-dom";
import FooterSite from "../FooterSite";



const Botonera = () => {
    const navigate = useNavigate();
    const [lugar, setLugar] = useState({lugar: "123"});

    const changeHandler = (e) => {
        const { name, value } = e.target;
        //alert("monos");
        setLugar({
          ...lugar,
          [name]: value,
        });
        //alert(patente).;
      };

    return (
        <>
       
     
       <div class="botoneraStyle" id="miBotonera">
                <div class="col-12 botoneraItemContainer">
                <div class= "col-2 botoneraEstacionamientos">&nbsp;
                </div>
                <div class="botoneraEstacionamientos col-2"> 
                  <img class="imagenBotoneraEstacionamiento" src="./estacionamient-icon-cred.svg" onClick={()=> navigate("/botoneracredito")}></img>
                  <h5 class="leyendaBotonera">Credito</h5>
                </div>
                <div class= "botoneraEstacionamientos col-1">
                  <img class="imagenSeparadorEstacionamiento" src="./estacionamient-separador.svg"/>
                </div>
                <div class="botoneraEstacionamientos col-2">
                  <img class="imagenBotoneraEstacionamiento" src="./estacionamient-icon-carga.svg"  onClick={()=> navigate("/botonerapuntoscarga")}></img>
                  <h5 class="leyendaBotonera">Puntos de carga</h5>
                </div>
                <div   class="botoneraEstacionamientos col-1">
                  <img class="imagenSeparadorEstacionamiento" src="./estacionamient-separador.svg"/>
                </div>
                
                <div class="botoneraEstacionamientos col-2">
                  <img class="imagenBotoneraEstacionamiento" src="./estacionamient-icon-gral.svg"onClick={()=> navigate("/botonerainfogral")} ></img>
                  <h5 class="leyendaBotonera">Info general</h5>
                </div>
                {/*<div   class="botoneraEstacionamientos col-1">
                  <img class="imagenSeparadorEstacionamiento" src="./estacionamient-separador.svg"/>
    </div>   */}             
                {/*<div class="botoneraEstacionamientos col-2">
                  <img class="imagenBotoneraEstacionamiento marginImg" src="./estacionamient-icon-free.svg" onClick={()=> navigate("/botoneragratuitos")}></img>
                  <h5 class="leyendaBotonera">Estacionamiento gratuito</h5>
    </div>*/}
                </div>
            </div>
      
           
        
        
        
        
        </>

    );
    }
export default Botonera;